module.exports = __webpack_public_path__ + "static/media/W29F4006-WEB5.514d4297.svg";